import { Button, Stack, styled, Tooltip } from '@mui/material'
// import { DepositSelectAssets } from 'views/Deposit/DepositSelectAssets'
import { ActionButton } from 'components/Buttons/ActionButton'
import Loading from 'components/Loading'
import ModalLink from 'components/ModalLink'
import { memo, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  useAccountInfo,
  useActivateStatus,
  useActivating,
  useIsActivated,
} from 'store/account/hooks'
import { updateOpenRenderFlag } from 'store/app/actions'
import { useModal, useOpenRenderFlag } from 'store/app/hooks'
import { DepositModalOption } from 'store/deposit/types'
import { ContentWrap, Flex } from 'styles'
import { DepositQrcode } from 'views/Deposit/DepositQrcode'
import { DepositTypeList } from 'views/Deposit/DepositSelectOption'
import { FaucetMainWrap } from 'views/Faucet'
import { FaucetLayer2 } from 'views/Faucet/FaucetLayer2'
import { updateModal } from '../../store/app/actions/modalActions'
import { useActivateAccount } from '../../hooks/link/useActivateAccount'
import { DepositContent } from '../../views/Deposit/DepositContent'
import { COMMUNITY_LINKS } from '../../constants/community'
import { ReferralsInput } from '../../views/Rewards/Refer/ReferralsInput'
import { IconInfo } from 'components/Icons'
import { ReactComponent as IconLayer2 } from './assets/layer2.svg'
import { ReactComponent as IconActivate } from './assets/activate.svg'
import { ReactComponent as IconSuccessful } from './assets/successful.svg'
import { ReactComponent as IconTrading } from './assets/trading.svg'
import { OpenMyAccountStep } from 'components/OpenMyAccountStep'

const DepositAssetsContent = styled(Flex)`
  font-size: 14px;
  line-height: 24px;
  flex-direction: column;
  color: ${(props) => props.theme.color.text70};
`
const DepositTips = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(199, 255, 92, 1);
  font-size: 12px;
  line-height: 18px;
  padding: 6px 16px;
  margin-top: 32px;
  background-color: rgba(160, 238, 9, 0.1);
  border-radius: 4px;

  b {
    font-weight: 600;
  }
`
const Wallet = styled(Flex)`
  flex-direction: column;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  &.deposit {
    margin-top: 16px;
  }
  &.faucet {
    margin-top: 10px;
  }
`
const WalletTitle = styled(Flex)`
  color: rgba(202, 213, 220, 1);
  font-size: 14px;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  .icon-help {
    height: 20px;
    display: flex;
    align-items: center;
    font-weight: 400;
    color: ${(props) => props.theme.color.primary30};
  }
`
const ActiveAccountContent = styled(DepositAssetsContent)`
  line-height: 20px;
  font-size: 14px;
`
const Active = styled(Flex)`
  gap: 16px;
  background: rgba(22, 25, 30, 1);
  border-radius: 6px;
  padding: 16px;
  align-items: center;
  margin-top: 16px;
`
const ActiveTitle = styled(Flex)`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => props.theme.color.text90};
`
const ActiveDesc = styled(Flex)`
  flex-direction: column;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.color.text60};
`
const ActiveBtn = styled(Button)`
  gap: 8px;
  height: 32px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 20px;
  border-radius: 16px;
`
const CompleteContent = styled(Stack)`
  align-items: center;
  span {
    font-size: 14px;
  }
`
const CongratulationWrap = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  span {
    color: rgba(149, 164, 173, 1);
  }
`
const CongratulationTitle = styled('div')`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: rgba(255, 255, 255, 1);
  padding: 8px 0;
`
const StartTradingButton = styled(ActionButton)`
  width: 198px;
  height: 40px;
  margin: 24px 0;
  font-size: 16px;
  line-height: 24px;
  border-radius: 20px;
`
const CongratulationsAnimate = styled(Flex)`
  align-items: center;
  justify-content: center;
  padding: 24px 0;
`

export const OpenMyAccountModal = memo(() => {
  const dispatch = useDispatch()
  const openMyAccountModal = useModal('guide')
  const { userId = 0, layer2Id = 0 } = useAccountInfo()
  const activateStatus = useActivateStatus()
  const isActivated = useIsActivated()
  const [activeStep, setActiveStep] = useState(0)
  const [completeOpenMyAccount, setCompleteOpenMyAccount] = useState(false)
  const openRenderFlag = useOpenRenderFlag()
  const activating = useActivating()
  const activateAccount = useActivateAccount()

  useEffect(() => {
    if (!userId) {
      setActiveStep(0)
      setCompleteOpenMyAccount(false)
    } else if (!isActivated) {
      setActiveStep(1)
      setCompleteOpenMyAccount(false)
    } else {
      setCompleteOpenMyAccount(true)
    }
  }, [isActivated, userId, layer2Id, activateStatus])

  if (isActivated) return null

  const renderContent = () => {
    if (openRenderFlag === 0) {
      return (
        <ContentWrap>
          {!completeOpenMyAccount && <OpenMyAccountStep step={activeStep} />}

          {!completeOpenMyAccount && activeStep === 0 && (
            <DepositAssetsContent>
              <DepositTips>
                <b>
                  Select one of the following choice to activate your ZKEX
                  account
                </b>
              </DepositTips>
              <Wallet className="deposit" key="deposit">
                <WalletTitle>
                  Deposit from Wallet
                  <Tooltip
                    title={
                      'It requires you have ZKEX supported tokens in your web3'
                    }
                  >
                    <div className="icon-help">
                      <IconInfo />
                    </div>
                  </Tooltip>
                </WalletTitle>
                <DepositTypeList
                  onSelectOption={(option) => {
                    if (option === DepositModalOption.SelectAssets) {
                      dispatch(
                        updateOpenRenderFlag({
                          flag: 2,
                        }),
                      )
                    } else if (option === DepositModalOption.Qrcode) {
                      dispatch(
                        updateOpenRenderFlag({
                          flag: 3,
                        }),
                      )
                    }
                  }}
                />
              </Wallet>
            </DepositAssetsContent>
          )}
          {!completeOpenMyAccount && activeStep === 1 && (
            <ActiveAccountContent>
              <DepositTips>
                <IconInfo style={{ width: '24px', height: '24px' }} />
                <div>
                  This is the last signature before using ZKEX service. Signing
                  is free and will not send a transaction.
                </div>
              </DepositTips>

              <Active>
                <IconLayer2 />
                {layer2Id ? (
                  <>
                    <Stack flex="1" spacing={1}>
                      <ActiveTitle>Enable trading</ActiveTitle>
                      <ActiveDesc>
                        Activate your ZKEX account on layer2
                      </ActiveDesc>
                    </Stack>
                    <ActiveBtn
                      variant="contained"
                      size="small"
                      onClick={() => {
                        if (activating) return

                        activateAccount()
                      }}
                    >
                      {activating ? (
                        <Loading color="inherit" />
                      ) : (
                        <IconActivate />
                      )}
                      <span>{activating ? 'Activating' : 'Activate'}</span>
                    </ActiveBtn>
                  </>
                ) : (
                  <>
                    <Stack flex="1" spacing={1}>
                      <ActiveTitle>Thank You for Your Deposit</ActiveTitle>
                      <ActiveDesc>
                        <div>
                          Please wait for zkLink to confirm your deposit.
                        </div>
                        <div>
                          If it takes longer than 5 minutes, please contact us
                          on Discord.
                        </div>
                      </ActiveDesc>
                    </Stack>
                    <ActiveBtn
                      variant="contained"
                      size="small"
                      onClick={() => {
                        window.open(COMMUNITY_LINKS.DISCORD, '_blank')
                      }}
                    >
                      <span>Discord</span>
                    </ActiveBtn>
                  </>
                )}
              </Active>
              {layer2Id ? <ReferralsInput /> : null}
            </ActiveAccountContent>
          )}

          {completeOpenMyAccount && (
            <CompleteContent>
              <CongratulationsAnimate>
                <IconSuccessful />
              </CongratulationsAnimate>
              <CongratulationWrap>
                <CongratulationTitle>Congratulations!</CongratulationTitle>

                <span>You've successfully setup your ZKEX account.</span>
                <div>
                  <StartTradingButton
                    variant="contained"
                    onClick={() => {
                      setCompleteOpenMyAccount(false)
                      dispatch(updateModal({ modal: 'guide', open: false }))
                    }}
                  >
                    <IconTrading /> Start trading
                  </StartTradingButton>
                </div>
              </CongratulationWrap>
            </CompleteContent>
          )}
        </ContentWrap>
      )
    } else if (openRenderFlag === 1) {
      return (
        <FaucetMainWrap>
          <FaucetLayer2 />
        </FaucetMainWrap>
      )
    } else if (openRenderFlag === 2) {
      return <DepositContent />
    } else if (openRenderFlag === 3) {
      return <DepositQrcode />
    }
    return null
  }

  return (
    <ModalLink
      width="435px"
      isIn={openMyAccountModal}
      header={openRenderFlag === 0 ? 'Open My Account' : 'Select Asset'}
      onClose={() => {
        dispatch(updateModal({ modal: 'guide', open: false }))
      }}
      onHeaderClick={
        openRenderFlag === 0
          ? undefined
          : () => {
              dispatch(
                updateOpenRenderFlag({
                  flag: 0,
                }),
              )
            }
      }
    >
      {renderContent()}
    </ModalLink>
  )
})
